/** AR03 copy (one group per control; a ticket edits only its own file). */
export const ar03PtBr = {
  title: 'Serviços entregues e não faturados',
  description: 'Entregas e medições sem fatura ou sem reconhecimento de receita.',
  prerequisite: 'Requer fontes esperadas para entregas fora dos cronogramas.',
  diagnosticLabel: 'Diagnóstico de entregas capturadas',
  reasons: {
    UNBILLED_DELIVERY: 'Entregue e não faturado',
    UNRECOGNIZED_DELIVERY: 'Entregue e não reconhecido',
    COVERAGE_LIMIT: 'Situação de faturamento indeterminada',
  },
  sources: {
    AR03_MILESTONE_EVIDENCE: 'Evidência de marcos',
    AR03_USAGE_RECORD: 'Registros de uso',
  },
  coverage: {
    through: 'Dados até {{date}}',
    absent: 'Sem fonte registrada',
    truncated: 'Mostrando parte do total; os números completos estão no resumo acima.',
  },
};

export const ar03En: typeof ar03PtBr = {
  title: 'Delivered but unbilled services',
  description: 'Deliveries and measurements without an invoice or revenue recognition.',
  prerequisite: 'Needs expected sources for deliveries outside the schedules.',
  diagnosticLabel: 'Captured delivery diagnostic',
  reasons: {
    UNBILLED_DELIVERY: 'Delivered, not billed',
    UNRECOGNIZED_DELIVERY: 'Delivered, not recognized',
    COVERAGE_LIMIT: 'Billing status undetermined',
  },
  sources: {
    AR03_MILESTONE_EVIDENCE: 'Milestone evidence',
    AR03_USAGE_RECORD: 'Usage records',
  },
  coverage: {
    through: 'Data through {{date}}',
    absent: 'No source on record',
    truncated: 'Showing part of the total; the full numbers are in the summary above.',
  },
};
